var _defs, _style, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadingSpinnerGradient = function SvgLoadingSpinnerGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    stroke: "#fafcff",
    viewBox: "0 0 86 86"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loading-spinner-gradient_svg__gradient",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes spinner_zKoa{to{transform:rotate(360deg)}}@keyframes spinner_YpZS{0%{stroke-dasharray:0 700;stroke-dashoffset:0}47.5%{stroke-dasharray:200 700;stroke-dashoffset:-70}95%,to{stroke-dasharray:200 700;stroke-dashoffset:-239}}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 38,
    fill: "none",
    stroke: "var(--gray-600)",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "center",
      animation: "spinner_zKoa 2s linear infinite"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 38,
    fill: "none",
    stroke: "url(#loading-spinner-gradient_svg__gradient)",
    strokeWidth: 6,
    className: "loading-spinner-gradient_svg__spinner_V8m1",
    style: {
      strokeLinecap: "round",
      animation: "spinner_YpZS 1.5s ease-in-out infinite"
    }
  })));
};
export default SvgLoadingSpinnerGradient;